// @flow
import React, { Component } from 'react';
import compose from 'lodash/flowRight';
import moment from 'moment';
import Day from './Day';
import { isSameDay } from '../../../../utils/date-utils';
import withSelectable from './withSelectable';
import withProps from '../../../../utils/withProps';

function withSingleSelection(CalendarComponent) {
  return class WithSingleSelection extends Component {
    state = {
      selectedDate: undefined
    };

    SelectableDayComponent: Component<*, *, *>;

    constructor() {
      super(...arguments);

      this.state = {
        selectedDate: this.props.selectedDate || undefined,
      };

      const enhance = compose([
        withProps((props) => ({
          onClick: this.handleClick,
          selected: this.state.selectedDate && isSameDay(props.date, this.state.selectedDate)
        })),
        withSelectable
      ]);

      this.SelectableDayComponent = enhance(Day);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.selectedDate !== this.props.selectedDate) {
        this.setState({
          selectedDate: nextProps.selectedDate
        });
      }
    }

    handleClick = (selectedDate: moment) => {
      this.setState({
        selectedDate
      });

      this.props.onDateSelected(selectedDate);
    }

    render() {
      return <CalendarComponent DayComponent={this.SelectableDayComponent} {...this.props} />; 
    }
  };
};

export default withSingleSelection;


// WEBPACK FOOTER //
// ./src/modules/common/components/calendar/withSingleSelection.js